import { AsyncThunkAction } from '@reduxjs/toolkit';

import { AppDispatch, RootState } from 'src/state/types';

import {
  fetchAccountInfoActionCreator,
  fetchAccountsActionCreator,
  fetchPartnersActionCreator,
  fetchShopStatusActionCreator,
  fetchProductsWithEligibilityActionCreator,
} from './action-creators';
import { RequestType, Resource } from './types';

export const Requests: Record<
  RequestType,
  AsyncThunkAction<
    Resource,
    void,
    {
      state: RootState;
      dispatch: AppDispatch;
    }
  >
> = {
  GET_ACCOUNTS: fetchAccountsActionCreator(),
  GET_PARTNERS: fetchPartnersActionCreator(),
  GET_ACCOUNT_INFO: fetchAccountInfoActionCreator(),
  GET_SHOP_STATUS: fetchShopStatusActionCreator(),
  GET_PRODUCTS_WITH_ELIGIBILITY: fetchProductsWithEligibilityActionCreator(),
};
